import instance from "../axiosConfig";
import { Page } from "./models";

export class ContentService {
    private regionCode: string;
    private languageCode: string;

    constructor(regionCode: string, languageCode: string) {
        this.regionCode = regionCode;
        this.languageCode = `${regionCode}-${languageCode}`;
    }

    getPages = async (): Promise<Page[]> => {
        const response = await instance.get<Page[]>(
            `/api/regions/${this.regionCode}/languages/${this.languageCode}/pages`
        );

        return response.data;
    };

    getPage = async (pageSlug: string): Promise<Page | null> => {
        try {
            const response = await instance.get<Page>(
                `/api/regions/${this.regionCode}/languages/${this.languageCode}/pages/${pageSlug}`
            );

            return response.data;
        } catch (error) {
            console.error("Error fetching page:", error);
            return null;
        }
    };
}
